import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsItemCollectionStaffInfoParm } from "./wsItemCollectionStaffInfo";
import { wsItemCollectionStaffUpdateInfo } from "./wsItemCollectionStaffInfo";

import { wsItemCollectionStaffAddEditInfoParm } from "./wsItemCollectionStaffAddEditInfo";
import { wsItemCollectionStaffAddEditUpdateInfoParm } from "./wsItemCollectionStaffAddEditInfo";

@Injectable()
export class DataService_itemcollection {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStaffSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStaffSelectList(parm: wsItemCollectionStaffInfoParm) 
	{
		var postResult$ = new Subject();
		var url = "Staff/ItemCollectionStaffSelectList";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStaffUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStaffUpdate(parm: wsItemCollectionStaffUpdateInfo) 
	{
		var postResult$ = new Subject();
		var url = "Staff/ItemCollectionStaffUpdate";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}	

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStaffAddEditGetData
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStaffAddEditGetData(parm: wsItemCollectionStaffAddEditInfoParm) 
	{
		var postResult$ = new Subject();
		var url = "Staff/ItemCollectionStaffAddEditGetData";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStaffAddEditUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStaffAddEditUpdate(parm: wsItemCollectionStaffAddEditUpdateInfoParm) 
	{
		var postResult$ = new Subject();
		var url = "Staff/ItemCollectionStaffAddEditUpdate";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}		
}
